import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import Url from "../../apiBaseUrl/APIConfig";
import type { JwtTokenAuthBody  } from "./Model";
import type { LoginResponse } from "./Model"
import { setupInterceptorsTo } from "../authenticationInterceptors/Interceptors";

type InitialState = {
  loading: boolean;
  response: LoginResponse;
  successMsg: string;
  error: string;
};
const initialState: InitialState = {
  loading: false,
  response: {} as LoginResponse,
  successMsg: "",
  error: "",
};
const headers = {
  Accept: "application/json",
  "Content-type": "application/json",
};

export const jwtLogin = createAsyncThunk<LoginResponse, JwtTokenAuthBody>(
  "jwtLogin/jwtLogin",
  async (payload: JwtTokenAuthBody, { rejectWithValue }) => {
    return await setupInterceptorsTo(axios)
      .post(Url.baseUrl + "/api/token/", payload, { headers })
      .then((response) => response.data)
      .catch((error) =>
        rejectWithValue(
          error?.response?.data !== undefined
          ? error.response.data.message !== undefined
            ? error.response.data.message
            : 'Something went wrong'
          : 'Something went wrong',
        )
      );
  }
);

const jwtLoginSlice = createSlice({
  name: "jwtLogin",
  initialState,
  reducers: {
    updateJwtLoginClearMsg: (state) => {
      state.successMsg = "";
      state.error = "";
    },
    updateJwtLoginClearRes: (state) => {
      state.successMsg = "";
      state.error = "";
      state.response = {} as LoginResponse;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(jwtLogin.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      jwtLogin.fulfilled,
      (state, action: PayloadAction<LoginResponse>) => {
        state.loading = false;
        state.response = action.payload;
        state.successMsg = "Login Successfull";
        localStorage.setItem("access", action.payload.access);
        localStorage.setItem("refresh", action.payload.refresh);
      }
    );
    builder.addCase(jwtLogin.rejected, (state, action) => {
      state.loading = false;
      state.response = {} as LoginResponse;
      state.successMsg = "";
      state.error = String(action.payload!) || "Something went wrong";
    });
  },
});
export const { updateJwtLoginClearMsg, updateJwtLoginClearRes } = jwtLoginSlice.actions;
export default jwtLoginSlice.reducer;
